/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { Button } from "../ui/button";
import { Send, Verified } from "lucide-react";
import Confirmation from "../Confirmation";
import { Label } from "../ui/label";
import CustomLabelText from "../CustomLabelText";
import { PhoneInput } from "../ui/phone-input";
import { Checkbox } from "../ui/checkbox";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { API, fileUpload, get } from "../../config";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";

const CDDVerifyModal = ({
  listData,
  setCddItem,
  setCddId,
  cddItem,
  customerType,
  loading,
  setLoading,
  cddId,
  sectionType,
  fecthData,
  defaultMobile,
  defaultABN,
  cdd,
  pending = false,
}) => {
  const { fetchOrganizationContext, organizationData } = useOrganization();
  const [mobile, setMobile] = useState(defaultMobile);
  const [abn, setABN] = useState(defaultABN);
  const [acn, setACN] = useState();
  const [consent, setConsent] = useState();
  const [confirmVerify, setConfirmVerify] = useState(false);

  const [showUsage, setShowUsage] = useState(false);
  const [showResend, setShowResend] = useState(false);

  if (!mobile && defaultMobile) {
    setMobile(defaultMobile);
  }

  const used =
    customerType == 2
      ? organizationData?.organizationData?.kyc_details?.kyb?.used
      : organizationData?.organizationData?.kyc_details?.kyc?.used;
  const total =
    customerType == 2
      ? organizationData?.organizationData?.kyc_details?.kyb?.total
      : organizationData?.organizationData?.kyc_details?.kyc?.total;

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
      setCddItem();
      setMobile();
      setConsent();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmVerify(!confirmVerify);
  };

  const toggleShowUsage = () => {
    setShowUsage(!showUsage);
  };

  const toggleShowResend = (id, data) => {
    if (id && data) {
      setCddId(id);
      setCddItem(data);
    }
    setShowResend(!showResend);
  };

  const handleVerifyID = async () => {
    try {
      setLoading(true);
      if (customerType == 2) {
        const formData = new FormData();

        formData.append("abn", abn ? abn : "");
        formData.append("acn", acn ? acn : "");

        formData.append("kyc_id", cddId ? cddId : "");

        formData.append(
          "organization_id",
          organizationData?.organizationData?.id
            ? organizationData?.organizationData?.id
            : "",
        );

        await fileUpload(API.GET_CDD_VERFIY_KYB_CONTACT, formData);
      } else {
        await get(
          `${API.GET_CDD_VERFIY}/${cddId}?cdd=${cdd}&cdd_customer_type=${sectionType}&mobile=${mobile ? mobile : ""}&method=${cddItem?.method}&organization_id=${
            organizationData?.organizationData?.id
              ? organizationData?.organizationData?.id
              : ""
          }`,
        );
      }
      setLoading(false);
      fetchOrganizationContext();
      fecthData();
    } catch (error) {
      setLoading(false);
      fecthData();
    }
  };

  const handleResend = async (recordId, recordData) => {
    try {
      setLoading(true);

      await get(
        `${API.GET_CDD_RESEND}/${cddId ? cddId : ""}?organization_id=${
          organizationData?.organizationData?.id
            ? organizationData?.organizationData?.id
            : ""
        }`,
      );

      setLoading(false);
      toggleConfirmVerify(recordId, recordData);
      toggleShowResend();
      // await fecthData();
    } catch (error) {
      setLoading(false);
      fecthData();
    }
  };

  return (
    <div>
      <Button
        size={"sm"}
        className="h-6 px-2"
        onClick={() => {
          if (pending && listData?.method == 2) {
            toggleShowResend(listData?.id, listData);
          } else {
            toggleConfirmVerify(listData?.id, listData);
          }
        }}
      >
        <div className="flex items-center gap-1">
          {pending && listData?.method == 2 ? (
            <Send size={14} />
          ) : (
            <Verified size={14} />
          )}
          <span>{pending && listData?.method == 2 ? "Resend" : "Verify"}</span>
        </div>
      </Button>

      <Confirmation
        title={`Resend Request`}
        open={showResend}
        setOpen={setShowResend}
        toggleShow={() => {
          toggleShowResend();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>
              <p>
                <b>Are you sure you want to resend this request?</b>
              </p>
              <p>
                Your previous verification link will be disabled, and a new
                request will be sent. This will use one additional credit.
              </p>
            </div>
          </>
        }
        loading={loading}
        disabled={loading}
        okAction={async () => {
          handleResend(listData?.id, listData);
        }}
        cancelAction={() => {
          setShowResend(!showResend);
        }}
      />

      <Confirmation
        title={"Verify Data"}
        open={confirmVerify}
        setOpen={setConfirmVerify}
        toggleShow={() => {
          toggleConfirmVerify();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>Are you sure you want to verify the record?</div>
            <div className="grid grid-cols-1 text-left mt-2">
              {customerType == 2 ? (
                <>
                  <div className="grid gap-2 mb-2">
                    <Label htmlFor="abn">
                      <CustomLabelText
                        required={false}
                        labelText="ABN"
                        errorField={""}
                      />
                    </Label>
                    <ReactInputMask
                      id="abn"
                      type="text"
                      name="abn"
                      value={abn ? abn : ""}
                      onChange={(e) => {
                        setABN(e?.target?.value);
                      }}
                      mask="99 999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={cn(
                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                      )}
                    />
                  </div>

                  <div className="flex items-center gap-3 my-4">
                    <div className="h-px flex-1 bg-border" />
                    <span className="text-xs font-semibold uppercase text-muted-foreground">
                      OR
                    </span>
                    <div className="h-px flex-1 bg-border" />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="acn">
                      <CustomLabelText
                        required={false}
                        labelText="ACN"
                        errorField={""}
                      />
                    </Label>
                    <ReactInputMask
                      id="acn"
                      type="text"
                      name="acn"
                      value={acn ? acn : ""}
                      onChange={(e) => {
                        setACN(e?.target?.value);
                      }}
                      mask="999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={cn(
                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                      )}
                    />
                  </div>
                </>
              ) : (
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={cddItem?.method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setMobile(e);
                    }}
                    value={mobile}
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
              )}
              <div className="flex items-start space-x-2 mt-4">
                <Checkbox
                  id="terms"
                  checked={consent}
                  name="same_address"
                  onClick={() => {
                    setConsent(!consent);
                  }}
                />
                <label
                  htmlFor="terms"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                >
                  {customerType == 2
                    ? `I confirm that I am authorised to act on behalf of this company and consent to
                      the company’s beneficial ownership information being checked with document
                      issuers or official record holders via third-party systems for the purpose of
                      identifying and verifying the company’s ultimate beneficial owners.`
                    : `I confirm that I am authorised to conduct this identity check
                  and I consent to information being checked with the document
                  issuer or official record holder via third party systems for
                  the purpose of confirming customer identity. Would you like
                  Myna Australia Pty Ltd to verify the id now?`}
                </label>
              </div>
            </div>
          </>
        }
        disabled={
          customerType == 2
            ? !(consent && (abn || acn))
            : cddItem?.method === 2
              ? !(mobile && consent)
              : !consent
        }
        okAction={async () => {
          //   handleVerifyID();
          //   toggleConfirmVerify();
          toggleShowUsage();
        }}
        cancelAction={() => {
          setCddId(null);
          setConfirmVerify(!confirmVerify);
        }}
      />

      <Confirmation
        title={`${customerType == 2 ? "KYB" : "KYC"} Usage`}
        open={showUsage}
        setOpen={setShowUsage}
        toggleShow={() => {
          toggleShowUsage();
        }}
        className="sm:max-w-1/2"
        message={
          <>
            <div>{`Confirming this verification will consume 1 ${customerType == 2 ? "KYB" : "KYC"} token. Current usage: ${used}/${total}. Usage after confirmation: ${used + 1}/${total}?`}</div>
          </>
        }
        loading={loading}
        disabled={loading}
        okAction={async () => {
          handleVerifyID();
          toggleShowUsage();
          toggleConfirmVerify();
        }}
        cancelAction={() => {
          setShowUsage(!showUsage);
        }}
      />
    </div>
  );
};

export default CDDVerifyModal;
